import { BookmarkSwitch } from '@common/components/BookmarkSwitch';
import { useFormattedVolume } from '@common/hooks';
import { Collection } from '@features/Collection';
import { useCollectionAssets } from '@features/Collection/hooks/useCollectionAssets';
import { CollectionMetadata } from '@features/metadata/types';
import { Flex, Skeleton, Text } from '@radix-ui/themes';
import { Trans, useTranslation } from 'react-i18next';
import styles from './CollectionCard.module.css';

interface CollectionCardOverlayProps {
    collection: Collection;
    metadata: CollectionMetadata;
}

export const CollectionCardOverlay = ({
    collection,
    metadata,
}: CollectionCardOverlayProps) => {
    useTranslation('common');
    const { id: collectionId, technicalDetails } = collection;
    const { title, releaseYear } = metadata;
    const { itemCount, isLoading } = useCollectionAssets(
        { pageIndex: 0, pageSize: 1 },
        { collectionId },
    );
    const { formatVolume } = useFormattedVolume();
    const date = releaseYear; //new Date(created);

    return (
        <Flex
            className={styles.overlay}
            direction={'column'}
            justify={'between'}
            align={'start'}
            p={'3'}
            gap={'2'}
        >
            <Flex
                className={styles.detailsFlex}
                direction={'column'}
                gap={'1'}
                align={'start'}
            >
                <Text
                    size={'3'}
                    weight={'bold'}
                    align={'left'}
                    color={'gray'}
                    highContrast
                >
                    <Flex justify={'center'} gap={'1'}>
                        {title}
                    </Flex>
                </Text>

                <Skeleton loading={isLoading || !itemCount} minWidth={'80px'}>
                    <Text size={'2'} color={'gray'}>
                        {itemCount && (
                            <Trans
                                i18nKey={'asset'}
                                values={{ count: itemCount }}
                            />
                        )}
                    </Text>
                    <Text size={'1'} color={'gray'}>
                        {formatVolume(technicalDetails?.volume)}
                    </Text>
                </Skeleton>
            </Flex>

            <Flex width={'100%'} align={'center'} justify={'between'}>
                <Text size={'1'} color='gray'>
                    {/* <FormattedDate date={date} /> */}
                    {date}
                </Text>
                <BookmarkSwitch collection={collection} />
            </Flex>
        </Flex>
    );
};
